




import { Component, Vue, Watch } from "vue-property-decorator";
// @ts-ignore
import { dsMobileMenu } from "../ds-components/ds-components";

@Component({
	name: "main-header",
})
export default class MainHeader extends Vue {
	locale: string = "";

	mounted() {
		// load current locale from route parameter
		this.locale = this.$route.params.locale;
		// refresh locale selector
		// @ts-ignore
		$(".selectpicker#languageSelector").val(this.locale);
		// @ts-ignore
		$(".selectpicker#languageSelector").selectpicker("refresh");

		// eslint-disable-next-line new-cap
		const mobileMenu = new dsMobileMenu({
			container: ".main-header__navigation",
			menuSandwich: ".main-header__mobile-menu-container",
			closeButton: ".mob-menu-close-btn",
		});

		mobileMenu.init();
	}

	@Watch("locale")
	changeLocale(locale) {
		if (locale !== this.$route.params.locale) {
			this.$nextTick(() => {
				// @ts-ignore
				$(".selectpicker#languageSelector").val(locale);
				// @ts-ignore
				$(".selectpicker#languageSelector").selectpicker("refresh");
			});
			this.$router.push({ name: this.$route.name, params: { locale } });
		}
	}
}
